

export class UrlHelper {

    public static getQuery(params) {
        return Object.keys(params).map(key => key + '=' + params[key]).join('&');
    }


}


